import { render, staticRenderFns } from "./SubmitInformation.vue?vue&type=template&id=4744af50&scoped=true"
import script from "./SubmitInformation.vue?vue&type=script&lang=js"
export * from "./SubmitInformation.vue?vue&type=script&lang=js"
import style0 from "./SubmitInformation.vue?vue&type=style&index=0&id=4744af50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4744af50",
  null
  
)

export default component.exports